import Utils from '@/common/utils.js'
import ShowMessage from '@/components/messages/ShowMessage.js'
import ClinicalService from '@/services/clinical.service'
import { EventBus } from '@/event-bus.js';

export default {
    mixins: [ShowMessage,Utils],
    
    data() {
        return {
            usersFunction: [],
            variables: [], 
            lookUpValue: '',
            dsmvValues: '',
            keywords: [
                {
                    name: 'SetValidateStatus',
                    handle: this.setValidateStatusHandler,
                    countOfParameters: 0,
                    type: 'void'
                }, 
                {
                    name: 'TextContainsValue',
                    handle: this.textContainsValueHandler,
                    countOfParameters: 3,
                    type: 'string'
                },
                {
                    name: 'GetControlValueByName',
                    handle: this.getControlValueByNameHandler,
                    countOfParameters: 1,
                    type: 'string'
                },
                {
                    name: 'SetControlValidate',
                    handle: this.setControlValidateHandler,
                    countOfParameters: 1,
                    type: 'void'
                },
                {
                    name: 'UpdateNotesHeaderField',
                    handle: this.updateNotesHeaderFieldHandler,
                    countOfParameters: 2,
                    type: 'void'
                },
                                {
                    name: 'SetControlsRequired',
                    handle: this.setControlsRequiredHandler,
                    countOfParameters: 2,
                    type: 'void'
                },
                {
                    name: 'SetControlValueByName',
                    handle: this.setControlValueByNameHandler,
                    countOfParameters: 2,
                    type: 'void'
                },
                {
                    name: 'ExecuteMultiLinesQuery',
                    handle: this.executeMultiLinesQueryHandler,
                    countOfParameters: 7,
                    type: 'void'
                },
                {
                    name: 'GetLookUpValue',
                    handle: this.getLookUpValueHandler,
                    countOfParameters: 3,
                    type: 'string'
                },
                {
                    name: 'SetControlValueItemsByName',
                    handle: this.setControlValueItemsByNameHandler,
                    countOfParameters: 2,
                    type: 'void'
                },
                {
                    name: 'GetListBoxCheckedCount',
                    handle: this.getListBoxCheckedCountHandler,
                    countOfParameters: 1,
                    type: 'number'
                },
                {
                    name: 'GetDSMVBySubstanceNCount',
                    handle: this.getDSMVBySubstanceNCountHandler,
                    countOfParameters: 3,
                    type: 'number'
                },
                {
                    name: 'GetTimeDuration',
                    handle: this.getTimeDurationHandler,
                    countOfParameters: 4,
                    type: 'number'
                },
                {
                    name: 'UpdateWorkflowStatus',
                    handle: this.updateWorkflowStatusHandler,
                    countOfParameters: 4,
                    type: 'void'
                },
                {
                    name: 'ResetListBoxChecked',
                    handle: this.resetListBoxCheckedHandler,
                    countOfParameters: 4,
                    type: 'void'
                }
            ],
        }
    },

    methods: {
        async evaluateExpressionByEvent(pascal_source) {
            let source = pascal_source.trim(); 
            const block = source.startsWith('begin'); 
            if (!block) {
                source = `
begin
    ${source}
end
                `
            }
            
            var ast = this.compile(block ? this.resolvedVariables(source) : source);
            await this.compute(ast);
        },

        resolvedVariables(value) {
            this.variables.forEach((element) => {
                value = value.replaceAll(new RegExp(element.name, 'gi'), `'${element.data}'`);
                value = value.replaceAll('\r\n', ';');
            });
            
            return value;
        },

        tokenize(input) {
            const tokens = [];
            const tokenRegex = /\s*(=>|:=|<>|<=|>=|[{}();]|[a-zA-Z_]\w*|\d+|\S)\s*/g;
            let match;
            while ((match = tokenRegex.exec(input))) {
                const values = match[0].split('\n');
                tokens.push({ key: match[1], value: values[0] });
                
                for (let index = 1; index < values.length; index++) {
                    const element = values[index];
                    tokens.push({ key: '\n', value: element });
                }
            }

            return tokens;
        },

        parse(tokens) {
            let index = 0;
            const ast = [];

            function parseStatements() {
                const statements = [];
                while (index < tokens.length && tokens[index].key !== 'end') {
                    parseToken(statements);
                }

                index++; // skip "end"
                return statements;
            }

            function parseStatement() {
                const name = tokens[index++].value;
                const params = [];
                while ((index < tokens.length) && tokens[index].key !== ';' && tokens[index].key !== '\n') {
                    params.push(tokens[index]);
                    index++;
                }

                return {
                    type: 'Statement',
                    name,
                    params
                }
            }

            function parseIf() {
                const conditions = [];
                while ((index < tokens.length) &&  tokens[index].key !== 'then') {
                    conditions.push(tokens[index++]);
                }
                index++; // skip "then"

                const body = [];
                while ((index < tokens.length) && tokens[index].key !== 'endif') {
                    parseToken(body);
                }
                index++; // skip "endif"

                return {
                        type: 'IfStatement',
                        conditions,
                        body
                    };
            }

            function parseProgram() {
                while ((index < tokens.length) && tokens[index].key !== ';' && tokens[index].key !== '\n') {
                    index++;
                }

                index++; // skip ";" or "\n"
            }

            function parseToken(element) {
                if (tokens[index].key === 'program') {
                    index++; // skip "program"
                    parseProgram();
                }
                else if (tokens[index].key === 'begin') {
                    index++; // skip "begin"
                    element.push(parseStatements());
                } else if (tokens[index].key === 'if') {
                    index++; // skip "if"
                    element.push(parseIf());
                } else if (tokens[index].key === ';') {
                    index++; // skip ";"
                } else if (tokens[index].key === '\n') {
                    index++; // skip "\n"
                } else if (tokens[index].key.match(/^[a-z0-9]+$/i)) {
                    element.push(parseStatement());
                } else {
                    index++; // skip other tokens
                }
            }

            while (index < tokens.length) {
                parseToken(ast);
            }

            return ast.flat();
        },

        compile(pascal_source) {
            const tokens = this.tokenize(pascal_source);
            const ast = this.parse(tokens);
            return ast;
        },

        async compute(ast) {
            for (let index = 0; index < ast.length; index++) {
                const node = ast[index];
                await this.computeNode(node);
            }
        },

        async computeNode(node) {
            if (node.type == 'IfStatement') {
                await this.computeNodeIf(node);
            } else if (node.type == 'Statement') {
                await this.computeNodeStatement(node);
            }
        },

        evalParameter(param) {
            try {
                const body = `return ${param}`;
                const functionHandle = new Function(body);
                return functionHandle();
            } catch {
                return param;
            }
        },

        async computeNodeStatement(node) {
            let index = 0;
            const func = node.name;
            const params = [];
            if (node.params.length !== 0) {
                const token = node.params[index];
                if (token.key === '(') {
                    index++; //skip "("
                }
            }
            
            await this.parseParameters({index: index, array: node.params}, params);
            const handler = this.keywords.find(text => text.name.localeCompare(func, undefined, { sensitivity: 'base' }) === 0);
            if (handler) {
                const variable = this.variables.find(text => text.name.localeCompare('result', undefined, { sensitivity: 'base' }) === 0);
                const result = await handler.handle(params);
                if (handler.type === 'string') {
                    if (variable) {
                        variable.data = result;
                        variable.typ = 'string';
                    }
                } else if (handler.type !== 'void') {
                    if (variable) {
                        variable.data = result;
                        variable.typ = handler.type;
                    }
                }
            }
        },

        async parseParentheses(data) {
            let str = '';
            while (data.index < data.array.length && data.array[data.index].key !== ')') {
                const token = data.array[data.index];
                if (token.key === '(') {
                    data.index++; // skip "("
                    const result = await this.parseParentheses(data);
                    str += `(${result}) `;
                } else if (this.keywords.some(text => text.name.localeCompare(token.key, undefined, { sensitivity: 'base' }) === 0)) {
                    const func = token.key;
                    data.index++; // skip

                    str += await this.parseStatement(data, func);
                } else if (this.variables.some(text => text.name.localeCompare(token.key, undefined, { sensitivity: 'base' }) === 0)) {
                    const variable = this.variables.find(text => text.name.localeCompare(token.key, undefined, { sensitivity: 'base' }) === 0);
                    data.index++; // skip

                    str += variable.typ === 'string' ? `'${variable.data}'` : '';
                } else if (token.key === 'AND') {
                    str += ' && ';
                    data.index++;
                } else if (token.key === 'OR') {
                    str += ' || ';
                    data.index++;
                } else if (token.key === '<>') {
                    str += ' != ';
                    data.index++;
                } else if (token.key === '=') {
                    str += ' == ';
                    data.index++;
                } else if (token.key === '\'') {
                    data.index++; //skip '
                    str += `'${this.parseString(data)}'`;
                } else {
                    str += token.value;
                    data.index++;
                }
            }

            data.index++; // skip ")"
            return str;
        },

        async parseStatement(data, func) {
            const token = data.array[data.index];
            if (token.key === '(') {
                data.index++; //skip "("
            }

            const params = [];
            await this.parseParameters(data, params)
            
            const handler = this.keywords.find(text => text.name.localeCompare(func, undefined, { sensitivity: 'base' }) === 0);
            if (handler) {
                const result = await handler.handle(params);
                if (handler.type === 'string') {
                    return `'${result}'`;
                } else if (handler.type !== 'void') {
                    return `${result}`;
                }

                return '';
            }
        },

        async parseParameters(data, params) {
            let str = '';
            let p = false;
            while (data.index < data.array.length) {
                const token = data.array[data.index];
                if (token.key === '(') {
                    data.index++; // skip "("
                    const result = await this.parseParentheses(data);
                    str += `(${result}) `;
                } else if (token.key === ')') {
                    data.index++; //skip ")"
                    break;
                } else if (token.key === ',') {
                    params.push(this.evalParameter(str));
                    str = ''; 
                    data.index++; //skip ","
                    p = false;
                } else if (token.key === 'AND') { 
                    str += ' && '; 
                    data.index++; //skip "AND"
                } else if (token.key === 'OR') { 
                    str += ' || '; 
                    data.index++; //skip "OR"
                } else {
                    str += await this.parseToken(data);	
                    p = true;
                }
            }

            if (str !== '' || p) {
                params.push(str !== '' ? this.evalParameter(str) : '');
            }
        },

        parseString(data) {
            let str = ''
            while ((data.index < data.array.length) && data.array[data.index].key !== '\'') {
                str += data.array[data.index].value;
                data.index++;
            }

            data.index++; // skip "'"
            return str;
        },

        async parseToken(data) {
            let str = '';
            const token = data.array[data.index];
            if (token.key === '(') {
                data.index++; // skip "("
                const result = await this.parseParentheses(data);
                str += `(${result}) `;
            } else if (token.key === '\'') {
                data.index++; // skip "'"
                str += `'${this.parseString(data)}'`;
            } else if (token.key.match(/^[0-9.]+$/i)) {
                data.index++;
                str += token.value;
            } else if (this.keywords.some(text => text.name.localeCompare(token.key, undefined, { sensitivity: 'base' }) === 0)) {
                const func = token.key;
                data.index++; // skip

                str += await this.parseStatement(data, func);
            } else if (this.variables.some(text => text.name.localeCompare(token.key, undefined, { sensitivity: 'base' }) === 0)) {
                const variable = this.variables.find(text => text.name.localeCompare(token.key, undefined, { sensitivity: 'base' }) === 0);
                data.index++; // skip

                str += variable.typ === 'string' ? `'${variable.data}'` : '';
            }
            else {
                data.index++;
            }

            return str;
        },

        async computeNodeIf(node) {
            let data = {index: 0 , array: node.conditions};
            let str = '';

            while (data.index < data.array.length) {
                let token = data.array[data.index];
                if (token.key === '(') {
                    data.index++; // skip "("
                    const result = await this.parseParentheses(data);
                    str += `(${result}) `;
                } else if (token.key === 'AND') { 
                    str += ' && '; 
                    data.index++; //skip "AND"
                
                } else if (token.key === 'OR') { 
                    str += ' || '; 
                    data.index++; //skip "OR"
                } else {
                    str += await this.parseToken(data);	
                }
            }
            
            const body = `return ${str}`;
            const functionHandle = new Function(body);
            if (functionHandle()) {
                node.body.forEach(this.computeNode, this);
            }
        },

        addUserFunction(name, countOfParameters, handle) {
            this.usersFunction.push({
                name, 
                countOfParameters,
                handle
            });
        },

        getUserFunctionHandleByName(name) {
            const userFunc = this.usersFunction.find(element => element.name == name);
            if (userFunc) {
                return userFunc.handle;
            } 
        },

        addStringVariable(name, value) {
            let element = this.getUserVariable(name);
            if (element) {
                element.data = value ? `${value}`.trim() : '';
            } else {
                this.variables.push({
                    typ: 'string',
                    name: name.toUpperCase(),
                    data: value ? `${value}`.trim() : ''
                });
            }
        },

        addNumericVariable(name, value) {
            let element = this.getUserVariable(name);
            if (element) {
                element.data = value;
            } else {
                this.variables.push({
                    typ: 'number',
                    name: name.toUpperCase(),
                    data: value
                });
            }
        },

        getVariableValue(name) {
            const element = this.getUserVariable(name);
            if (element) {
                return element.data;
            }
        },

        getUserVariable(name) {
            const upperName = name.toUpperCase();
            return this.variables.find(element => element.name == upperName);
        },

        setControlValidateHandler(parameters) {
            const value = parameters[0];
            
            const functionHandle = this.getUserFunctionHandleByName('SetControlValidate');
            if (functionHandle) {
                return functionHandle(value);
            }
        },

        textContainsValueHandler(parameters) {
            const value = parameters[0];
            const text = parameters[1];
            const separator = parameters[2];

            const functionHandle = this.getUserFunctionHandleByName('TextContainsValue');
            if (functionHandle) {
                return functionHandle(value, text, separator);
            }
        },

        getControlValueByNameHandler(parameters) {
            const controlName = parameters[0];
            const functionHandle = this.getUserFunctionHandleByName('GetControlValueByName');
            if (functionHandle) {
                return functionHandle(controlName);
            }
        },

        updateNotesHeaderFieldHandler(parameters) {
            const fieldName = parameters[0];
            const fieldValue = parameters[1];

            const functionHandle = this.getUserFunctionHandleByName('UpdateNotesHeaderField');
            if (functionHandle) {
                return functionHandle(fieldName, fieldValue);
            }
        },

        setControlValueByNameHandler(parameters) {
            const controlName = parameters[0];
            const controlValue = parameters[1];
            
            const functionHandle = this.getUserFunctionHandleByName('SetControlValueByName');
            if (functionHandle) {
                functionHandle(controlName, controlValue);
            }
        },

        executeMultiLinesQueryHandler(parameters) {
            const controlName = parameters[0];
            const queryParameters = {
                viewName: parameters[1],
                fieldName: parameters[2],
                conditions: [
                    parameters[3],
                    parameters[4],
                    parameters[5],
                    parameters[6]
                ].filter(x => x.trim().length > 0),
                selfValue: this.getVariableValue('SelfValue'),
                recordID: this.getVariableValue('RecordID'),
                txHeaderID: this.getVariableValue('TXHeaderID')
            }
            
            EventBus.$emit('ShowWeel', true);
            ClinicalService.setTokenConditionValues(queryParameters)
                    .then((response) => { 
                        let values = [];
                        if(response.data && response.data.length > 0) {
                            values = response.data.filter(x => x.trim().length != 0);
                        }

                        const functionHandle = this.getUserFunctionHandleByName('SetControlValueItemsByName');
                        if (functionHandle) {
                            functionHandle(controlName, values);
                        }

                        EventBus.$emit('ShowWeel', false);
                    })
                    .catch(error => {
                        EventBus.$emit('ShowWeel', false);
                        this.showResponseErrorMessage(error);
                    });       
        },

        async getLookUpValueHandler(parameters) {
            const queryParameters = {
                selfValue: this.getVariableValue('SelfValue').trim(),
                lookUpTable: parameters[0],
                lookUpColumn: parameters[1],
                returnColumn: parameters[2]
            }

            this.lookUpValue = '';
            await ClinicalService.getLookUpValue(queryParameters)
                    .then((response) => { 
                        if(response.data && response.data.length > 0) {
                            this.lookUpValue = response.data;
                        }
                    })
                    .catch(error => {
                        this.showResponseErrorMessage(error);
                    });

            return this.lookUpValue;
        },

        setControlValueItemsByNameHandler(parameters) {
            const controlName = parameters[0];
            const controlValue = parameters[1];
            
            const functionHandle = this.getUserFunctionHandleByName('SetControlValueItemsByName');
            if (functionHandle) {
                functionHandle(controlName, controlValue);
            }
        },

        getListBoxCheckedCountHandler(parameters) {
            const controlName = parameters[0];

            const functionHandle = this.getUserFunctionHandleByName('GetListBoxCheckedCount');
            if (functionHandle) {
                return functionHandle(controlName);
            }
        },

        async getDSMVBySubstanceNCountHandler(parameters) {
            const controlNameHandle = this.getUserFunctionHandleByName('GetControlValueByName');
            const listBoxCheckHandle = this.getUserFunctionHandleByName('GetListBoxCheckedCount');
            this.dsmvValues = '';
            if (controlNameHandle && listBoxCheckHandle) {
                const queryParameters = {
                    lookUpTable: parameters[0],
                    countValue: listBoxCheckHandle(parameters[2]),
                    substanceValue: controlNameHandle(parameters[1])
                }

                if (queryParameters.countValue > 0 && queryParameters.substanceValue != undefined) {
                    await ClinicalService.getDSMVValues(queryParameters)
                        .then((response) => { 
                            if(response.data && response.data.length > 0) {
                                this.dsmvValues = response.data;
                            }
                        })
                        .catch(error => {
                            this.showResponseErrorMessage(error);
                        });
                }
            }

            return this.dsmvValues;
        },

        getTimeDurationHandler(parameters) {
            const durationUnit       = parameters[0];
            const controlOfTimeFrom  = parameters[1];
            const controlOfTimeTo    = parameters[2];
            const destinationControl = parameters[3];

            const functionHandle = this.getUserFunctionHandleByName('SetControlValueByName');
            if (functionHandle) {
                const result = this._getTimeDuration(durationUnit, controlOfTimeFrom, controlOfTimeTo);
                if (result != undefined) {
                    functionHandle(destinationControl, result);
                }
            }
        },

        updateWorkflowStatusHandler(parameters) {
            const queryParameters = {
                patientCode: parameters[0],
                incidentID: parameters[1],
                processID: parameters[2],
                workflowID: parameters[3]
            }
            
            EventBus.$emit('ShowWeel', true);
            ClinicalService.updateWorkflowStatus(queryParameters)
                    .then(() => EventBus.$emit('ShowWeel', false))
                    .catch(error => {
                        EventBus.$emit('ShowWeel', false);
                        this.showResponseErrorMessage(error);
                    });
        },

        setControlsRequiredHandler(parameters) {
            const fieldValue = parameters[0];
            const fieldList = parameters[1];
            
            const functionHandle = this.getUserFunctionHandleByName('SetControlsRequired');
            if (functionHandle) {
                functionHandle(fieldValue, fieldList);
            }
        },

        _getTimeDuration(durationUnit, controlOfTimeFrom, controlOfTimeTo) {
            const functionHandle = this.getUserFunctionHandleByName('GetControlValueByName');
            let result = '';
            if (functionHandle) {
                const format = 'hh:mm A';
                const startTimeStr = functionHandle(controlOfTimeFrom)?.trim();
                const endTimeStr   = functionHandle(controlOfTimeTo)?.trim();
                if (!Utils.isNullOrEmptyString(startTimeStr) && !Utils.isNullOrEmptyString(endTimeStr))
                {
                    const validStartTime = Utils.isValidTime(startTimeStr);
                    const validEndTime = Utils.isValidTime(endTimeStr);
                    if (!validStartTime) {
                        this.showMessage(this.$t('Msg.Warning'), this.$t('ExpressionBuilder.InvalidStartTime'), 'warning');
                    } else if (!validEndTime) {
                        this.showMessage(this.$t('Msg.Warning'), this.$t('ExpressionBuilder.InvalidEndTime'), 'warning');
                    } else {
                        const duration = durationUnit.toUpperCase();
                        if (duration == "M") {
                            result = Utils.diffBetween(startTimeStr, endTimeStr, format, 'minutes');
                        } else if (duration == "H") {
                            result = Utils.diffBetween(startTimeStr, endTimeStr, format, 'hours');
                        } else if (duration == "S") {
                            result = Utils.diffBetween(startTimeStr, endTimeStr, format, 'seconds');
                        } else {
                            this.showMessage(this.$t('ExpressionBuilder.Title'), this.$t('ExpressionBuilder.DurationNotImplemented'));
                        }
                    }
                }
            }

            return result;
        },

        resetListBoxCheckedHandler(parameters) {
            const fieldName = parameters[0];
            const fieldValue = parameters[1];
            
            const functionHandle = this.getUserFunctionHandleByName('ResetListBoxChecked');
            if (functionHandle) {
                functionHandle(fieldName, fieldValue);
            }
        }
    }
}